var map = {
	"./adult/back-btn.svg": 8946,
	"./confidence/back-btn.svg": 9772,
	"./couples/back-btn.svg": 4751,
	"./nice/back-btn.svg": 8665,
	"./psycho/back-btn.svg": 3668,
	"./quirky/back-btn.svg": 769,
	"./rude/back-btn.svg": 2774,
	"./sex/back-btn.svg": 6858,
	"./spicy-couple/back-btn.svg": 6485,
	"./spicy/back-btn.svg": 6820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5346;